import type { LucideIcon } from 'lucide-react';

import { useResponsive } from '../../../hooks/useResponsive';
import AccordionDesktop from './AccordionDesktop';
import AccordionMobile from './AccordionMobile';

export interface AccordionProps {
  icon: LucideIcon;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const Accordion = (props: AccordionProps) => {
  const breakpointIndex = useResponsive([768]);

  if (breakpointIndex === 0) {
    return <AccordionMobile {...props} />;
  }
  return <AccordionDesktop {...props} />;
};

export default Accordion;

export { default as AccordionItemDesktop } from './AccordionItemDesktop';
export { default as AccordionItemMobile } from './AccordionItemMobile';
